import React from "react";

// Custom import
import MainTemplate from "@/components/Templates/MainTemplate";

import FAQ, { FAQMobile } from "./FAQ";

export { FAQMobile };

function FaqPage() {
  return (
    <MainTemplate>
      <FAQ showHeader />
    </MainTemplate>
  );
}

export default FaqPage;
